import { Nomination } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNomination: (
  fetchContext: FetchContext,
  nomination: Nomination,
  accessToken?: string,
) => Promise<void> = (fetchContext, nomination, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nomination.nominationId}`, {
    method: 'PUT',
    body: JSON.stringify(nomination),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination'));
